import { useState, useCallback, useEffect, useRef } from 'react';
import { subscriptionAPI } from '../../services/subscriptionService';
import type { Subscription } from '../../types/subscription';

/** Só chama GET /admin/subscription quando enabled (ex.: apenas para admin). Evita 403 para não-admins. */
export const useSubscriptions = (options?: { enabled?: boolean }) => {
  const enabled = options?.enabled ?? true;
  const [latestSubscription, setLatestSubscription] = useState<Subscription | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const fetchInFlightRef = useRef(false);

  const fetchList = useCallback(async () => {
    if (!enabled) return;
    if (fetchInFlightRef.current) return;
    fetchInFlightRef.current = true;
    setIsLoading(true);
    setError(null);
    try {
      const data = await subscriptionAPI.getLatest();
      setLatestSubscription(data ?? null);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Erro ao carregar assinaturas');
    } finally {
      setIsLoading(false);
      fetchInFlightRef.current = false;
    }
  }, [enabled]);

  useEffect(() => {
    if (enabled) fetchList();
  }, [enabled, fetchList]);

  return {
    latestSubscription,
    isLoading,
    error,
    refetch: fetchList,
  };
};
